import { Resources } from '../models/ScheduleResource';

export const compareResources = (a: Resources, b: Resources) => {
  if (a.priority === null && b.priority === null) {
    return 0;
  } else if (a.priority === null) {
    return 1;
  } else if (b.priority === null) {
    return -1;
  }

  return a.priority - b.priority;
};
